import React from "react";

const WishContext=React.createContext();

export default WishContext;